import { render } from "./ProjectTabUser.vue?vue&type=template&id=2d9a668c&scoped=true&ts=true"
import script from "./ProjectTabUser.vue?vue&type=script&lang=ts"
export * from "./ProjectTabUser.vue?vue&type=script&lang=ts"

import "./ProjectTabUser.vue?vue&type=style&index=0&id=2d9a668c&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9a668c"]])

export default __exports__